










































import { Component, Mixins } from "vue-property-decorator";
import {
  ModelEditableMixin,
} from "../../../../../../base/components/system/mixins";
import { FormatStructureEditableMixin } from "../../mixins";

interface IDeleteLimit {
  section: string;
  target: string;
}

@Component({
  components: {
  },
})
export default class FormatPropertyLimitDeleteLimitsEditTool extends Mixins(ModelEditableMixin, FormatStructureEditableMixin) {
  // TODO FormatStructureEditableMixin、FormatStructureEditor、IEditableFormatStructureに移動する
  enabled: boolean = false;
  deleteLimits: IDeleteLimit[] = [
    { section: "ユーザ", target: "クライオ管理者" },
    { section: "記載者", target: "記載者ユーザ" },
  ];
  selectedDeleteLimit: IDeleteLimit = null;

  get hasSelectedLimit(): boolean {
    return !!this.selectedDeleteLimit;
  }

  openDialog(): void {
    this.$notImplemented();
  }

  removeSelectedLimit(): void {
    this.$notImplemented();
  }

  async handleSelectionChanged(row: IDeleteLimit): Promise<void> {
    this.selectedDeleteLimit = row;
  }
}
